<script>

export function useDebounce() {
    let timerId;
    const debounce = (callback, options = { delay: 500, args: null }) => {
        clearTimeout(timerId);
        timerId = setTimeout(() => {
            callback(options.args);
        }, options.delay);
    };

    return {
        debounce
    };
}

</script>
